module.exports = __webpack_public_path__ + "img/churrasco-plancha.9987555c.jpg";